import { Dispatch } from 'redux';
import actions from './actions';

import { AnchorAPI } from '../../../modules/AnchorAPI';

import { Episode } from './../../../types';

const { setEpisodeListStatus, setEpisodePendingDeletion } = actions;

const fetchAndLoadEpisodes = () => (dispatch: Dispatch<any>) => {
  dispatch(
    setEpisodeListStatus({
      kind: 'episodeListLoading',
    })
  );
  AnchorAPI.fetchEpisodes()
    .then((episodes: Episode[]) => {
      dispatch(
        setEpisodeListStatus({
          kind: 'episodeListLoaded',
          episodes,
        })
      );
    })
    .catch(() => {
      dispatch(
        setEpisodeListStatus({
          kind: 'episodeListFailed',
        })
      );
    });
};
const deleteAndFetchAndLoadEpisodes = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  dispatch(setEpisodePendingDeletion(null));
  AnchorAPI.deleteEpisode(episode).then((response: any) => {
    dispatch(setEpisodePendingDeletion(null));
    fetchAndLoadEpisodes()(dispatch);
  });
  // TODO: DO SOMETHING HERE!
  // .catch(err => {
  // });
};

const onComponentDidMount = fetchAndLoadEpisodes;
const onPressRequestDeleteEpisode = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  dispatch(setEpisodePendingDeletion(episode));
};
const onPressConfirmDeleteEpisode = deleteAndFetchAndLoadEpisodes;
const onPressDownloadEpisode = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  if (episode.status.kind === 'published') {
    // TODO: This should be in its own module
    const url: string = episode.status.fullEpisodeAudioFileUrl;
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = url;
    const fileName = episode.title || 'Untitled';
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
};
const onPressCopyEpisodeLink = (episode: Episode) => (
  dispatch: Dispatch<any>
) => {
  const { publicUrlPath } = episode;
  // TODO: This should be in its own module
  const host = `${window.location.protocol}//${window.location.hostname}`;
  const port = window.location.port;
  const hostAndPort = `${host}${port ? `:${port}` : ''}`;
  const url = `${hostAndPort}${publicUrlPath}`;

  // TODO: This should be in its own module
  const textField = document.createElement('textarea');
  textField.innerText = url;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};
const onPressCloseConfirmDeleteModal = () => (dispatch: Dispatch<any>) => {
  dispatch(setEpisodePendingDeletion(null));
};

export default {
  onComponentDidMount,
  onPressCloseConfirmDeleteModal,
  onPressConfirmDeleteEpisode,
  onPressCopyEpisodeLink,
  onPressDownloadEpisode,
  onPressRequestDeleteEpisode,
};
